<template>
  <p>Create</p>
</template>

<script>
export default {

}
</script>

<style>

</style>